import * as extension from '@starflow/app/extension';
import * as presetComponents from '../presets/components';
import * as presetMenu from '../presets/menu';

let contextMenu = presetMenu.contextMenu;
let rootComponents = presetComponents.rootComponents;
let subWindowComponents = presetComponents.subWindowComponents;
let navbarComponents = presetComponents.navbarComponents;
let panelComponents = presetComponents.panelComponents;

export const getContextMenu = () => {
  const extensionContextMenu = extension.getContextMenu();

  return {
    canvas: contextMenu.canvas.concat(extensionContextMenu.canvas),
    element: contextMenu.element.concat(extensionContextMenu.element),
    selection: contextMenu.selection.concat(extensionContextMenu.selection),
  };
};

export const modifyContextMenu = (modifier) => {
  contextMenu = modifier(contextMenu);
};

export const getRootComponents = () => {
  const extensionComponents = extension.getComponents();

  return rootComponents.concat(extensionComponents.root);
};

export const getSubWindowComponents = () => {
  const extensionComponents = extension.getComponents();

  return subWindowComponents.concat(extensionComponents.windows);
};

export const getNavBarComponents = () => {
  const extensionComponents = extension.getComponents();
  return {
    left: navbarComponents.left.concat(extensionComponents.navbar_left),
    center: navbarComponents.center.concat(extensionComponents.navbar_center),
    right: navbarComponents.right.concat(extensionComponents.navbar_right),
  };
};

export const getSelectionToolBarComponents = () => {
  return extension.getComponents().selection_overlayer;
};

export const modifyNavBarComponents = (modifier) => {
  navbarComponents = modifier(navbarComponents);
};

export const getLeftPanelComponents = () => {
  return panelComponents.left.concat(extension.getComponents().left_panel);
};

export const getBottomPanelComponents = () => {
  return panelComponents.bottom.concat(extension.getComponents().bottom_panel);
};

export const getRightPanelComponents = () => {
  return panelComponents.right.concat(extension.getComponents().right_panel);
};

export const getElementInfoPanelComponents = () => {
  return panelComponents.element_info.concat(extension.getComponents().element_info_panel);
};

export const modifyPanelComponents = (modifier) => {
  panelComponents = modifier(panelComponents);
};
